import { render, staticRenderFns } from "./siteAdminDeviceList.vue?vue&type=template&id=aff9e8fe&scoped=true&"
import script from "./siteAdminDeviceList.vue?vue&type=script&lang=js&"
export * from "./siteAdminDeviceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff9e8fe",
  null
  
)

export default component.exports